import { Typography } from '@mui/material';
import { DateView } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import _ from 'lodash';
import { makeStyles } from 'tss-react/mui';

interface Props {
  value: Date;
  label?: string;
  views?: DateView[];
  minDate?: Date | number;
  maxDate?: Date | number;
  variant?: 'background' | 'white';
  disabled?: boolean;
  style?: React.CSSProperties;

  onChange(date: unknown): void;
}

const PaiDatePicker: React.FC<Props> = ({ value, label, views, minDate, maxDate, variant = 'white', disabled, style, onChange }) => {
  const { classes } = useStyles({ variant, disabled });

  const minDateValue = minDate ? new Date(minDate) : undefined;
  const maxDateValue = maxDate ? new Date(maxDate) : undefined;

  return (
    <div style={{ width: style?.width || '100%', maxWidth: style?.maxWidth || undefined }}>
      {!_.isNil(label) ? <Typography className={classes.label}>{label}</Typography> : null}
      <DatePicker
        className={classes.datePicker}
        views={views}
        minDate={minDateValue}
        maxDate={maxDateValue}
        value={value}
        onChange={onChange}
        disabled={disabled}
        sx={style}
      />
    </div>
  );
};

const useStyles = makeStyles<{
  variant?: 'background' | 'white';
  disabled?: boolean;
}>()((theme, { variant, disabled }) => ({
  datePicker: {
    width: '100%',
    '& .MuiPickersInputBase-root': {
      padding: 0,
    },
    '& .MuiInputAdornment-root': {
      marginRight: '24px',
      marginLeft: '4px',
      '& .MuiButtonBase-root': {
        padding: '2px',
      },
    },
    '& .MuiPickersOutlinedInput-notchedOutline': {
      border:
        variant !== 'background' ? (disabled ? `1px solid ${theme.palette.action.disabled}` : `1px solid ${theme.palette.primary.main}`) : undefined,
      borderRadius: '10px',
    },
    '& .MuiSvgIcon-root': {
      color: disabled ? theme.palette.action.disabled : theme.palette.primary.main,
      fontSize: theme.typography.pxToRem(20),
    },
    '& .MuiPickersSectionList-root': {
      padding: '9px 12px !important',
      background: variant === 'background' ? theme.palette.backgrounds.main_new : '#FFF',
      fontSize: theme.typography.pxToRem(14),
      minHeight: '39px',
    },
    '& .MuiPickersSectionList-section': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  label: {
    marginBottom: '4px',
    marginLeft: '4px',
    fontSize: theme.typography.pxToRem(14),
  },
}));

export default PaiDatePicker;
